import React from 'react';
import {
  Lightbulb,
  TrendingUp,
  Users,
  ShieldCheck,
  BadgeCheck,
  Handshake,
  BrainCircuit,
  HeartHandshake,
  Rocket,
  Medal
} from 'lucide-react';

const SectionTitle = ({ subtitle, title, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center' : ''}`}>
    <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <div className="w-12 h-0.5 bg-[#F49611]"></div>
      <span className="text-[#F49611] font-medium uppercase tracking-wider text-sm">{subtitle}</span>
    </div>
    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">{title}</h2>
  </div>
);

const FeatureCard = ({ Icon, title, description, index }) => (
  <div className="group">
    <div className="relative p-8 rounded-xl bg-white border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <div className="absolute top-0 right-0 w-24 h-24 bg-[#E8EEF6] rounded-bl-full -z-10 group-hover:bg-[#F49611] transition-colors duration-300"></div>
      <div className="flex items-start gap-6">
        <div className="relative">
          <div className="w-12 h-12 rounded-xl bg-[#E8EEF6] group-hover:bg-[#F49611] transition-colors duration-300 flex items-center justify-center">
            <Icon className="w-6 h-6 text-[#113262] group-hover:text-white transition-colors duration-300" />
          </div>
          <span className="absolute -bottom-4 -right-4 text-4xl font-bold text-[#E8EEF6] group-hover:text-[#F49611]/10 transition-colors duration-300">
            {String(index).padStart(2, '0')}
          </span>
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-[#113262] mb-3">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  </div>
);

const Features = () => {
  const features = [
    {
      icon: Rocket,
      title: "Fast-Paced Growth",
      description: "Join a company that’s scaling rapidly — your impact is visible, your ideas are heard."
    },
    {
      icon: Lightbulb,
      title: "Innovation-Driven",
      description: "We use proprietary tech and data science to redefine how wealth is managed in India."
    },
    {
      icon: Users,
      title: "Collaborative Culture",
      description: "Work alongside a sharp, passionate team that values ownership and cross-functionality."
    },
    {
      icon: BrainCircuit,
      title: "Smart Leadership",
      description: "Led by IIT/IIM/CA founders with decades of domain expertise and modern outlooks."
    },
    {
      icon: ShieldCheck,
      title: "Stable Foundations",
      description: "Strong AUM, trusted clientele, and a robust business model that supports long-term careers."
    },
    {
      icon: HeartHandshake,
      title: "People-First Ethos",
      description: "We care about your growth, well-being, and work-life balance — genuinely."
    }
  ];

  return (
    <section className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <SectionTitle 
        subtitle="Why Maxiom Wealth"
        title="What Makes Us Different"
      />
      <div className="grid md:grid-cols-2 gap-8">
        {features.map((feature, index) => (
          <FeatureCard 
            key={index}
            Icon={feature.icon}
            title={feature.title}
            description={feature.description}
            index={index + 1}
          />
        ))}
      </div>
    </section>
  );
};

export default Features;
